import React from 'react';
import { Link } from 'react-router-dom';
import { GITHUB_URL, DISCORD_URL, MEDIUM_URL, X_URL } from '../config/const.js';

const Footer = () => {
  return (
    <footer>
      <div className="footer-divider"></div>
      <div className="footer-row">
        <div className="social-links">
          <a href={MEDIUM_URL} className="social-icon" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-medium"></i>
          </a>
          <a href={X_URL} className="social-icon" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-x-twitter"></i>
          </a>
          <a href={DISCORD_URL} className="social-icon" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-discord"></i>
          </a>
          <a href={GITHUB_URL} className="social-icon" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-github"></i>
          </a>
        </div>
        <div className="footer-links">
          <div className="link-group">
            <h4>Product</h4>
            <ul>
              <li><button className="link-button">Roadmap</button></li>
              <li><button className="link-button">Status</button></li>
              <li><button className="link-button">Changelog</button></li>
              <li><Link to="/pricing">Pricing</Link></li>
            </ul>
          </div>
          <div className="link-group">
            <h4>Resources</h4>
            <ul>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/docs">Docs <i className="fa-solid fa-arrow-up-right-from-square"></i></Link></li>
            </ul>
          </div>
          <div className="link-group">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/policy">Service Credits Terms</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-logo">
          <img src="/local/memu-logo.svg" alt="MemU" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;